import Image, { type ImageProps, type StaticImageData } from 'next/image';
import FollowUpBossSvg from 'public/img/icons/follow-up-boss.svg';

export const FollowUpBossIcon = (props: Omit<ImageProps, 'alt' | 'src'>) => {
  return (
    <Image
      alt="Follow Up Boss"
      width={20}
      src={FollowUpBossSvg as StaticImageData}
      {...props}
    />
  );
};
